import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-invoices',
  templateUrl: './view-invoices.component.html'
})
export class ViewInvoicesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
